const state = {
  rfpShortList: []
}

const mutations = {
  SET_RFP_SHORTLIST (state, payload) {
    state.rfpShortList = payload
  }
}

const actions = {
  setRfpShortList ({ commit }, payload) {
    commit('SET_RFP_SHORTLIST', payload)
  }
}

const getters = {
  getRfpShortList (state) {
    return state.rfpShortList
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
